(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brox-brand-directory"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('brox-brand-directory')) return;
  class BrandDirectory extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const normal = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      const items = [...this.querySelectorAll('[data-brand-item]')];
      const unique = new Map();
      items.forEach(item => {
        const name = item.dataset.brandName.trim();
        const key = normal(name);
        if (!key || unique.has(key)) { item.remove(); return; }
        unique.set(key, { item, name, key, letter: /^[a-z]/i.test(key) ? key[0].toUpperCase() : '#' });
      });
      this.records = [...unique.values()].sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' }));
      const holder = this.querySelector('[data-brand-groups]');
      const alphabet = this.querySelector('[data-brand-alphabet]');
      holder.replaceChildren();
      alphabet.replaceChildren();
      this.groups = [];
      '#ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').forEach(letter => {
        const records = this.records.filter(record => record.letter === letter);
        if (!records.length) {
          const unavailable = document.createElement('span');
          unavailable.className = 'bb-letter-disabled';
          unavailable.textContent = letter;
          alphabet.appendChild(unavailable);
          return;
        }
        const group = document.createElement('section');
        group.className = 'bb-group';
        group.id = 'BrandGroup-' + this.dataset.section + '-' + (letter === '#' ? 'numbers' : letter);
        const heading = document.createElement('h2');
        heading.textContent = letter;
        heading.id = group.id + '-heading';
        group.setAttribute('aria-labelledby', heading.id);
        const list = document.createElement('ul');
        list.className = 'bb-links';
        records.forEach(record => list.appendChild(record.item));
        group.append(heading, list);
        holder.appendChild(group);
        const link = document.createElement('a');
        link.href = '#' + group.id;
        link.textContent = letter;
        alphabet.appendChild(link);
        this.groups.push({ group, link, records });
      });
      const search = this.querySelector('[data-brand-search]');
      const filter = () => {
        const terms = normal(search.value).split(/\s+/).filter(Boolean);
        let count = 0;
        this.records.forEach(record => { record.item.hidden = !terms.every(term => record.key.includes(term)); if (!record.item.hidden) count++; });
        this.groups.forEach(({ group, link, records }) => {
          group.hidden = !records.some(record => !record.item.hidden);
          link.hidden = group.hidden;
        });
        this.querySelector('[data-brand-empty]').hidden = count > 0;
        this.querySelector('[data-brand-count]').textContent = count + ' ' + this.dataset.countLabel;
      };
      search.addEventListener('input', filter, options);
      this.querySelector('[data-brand-clear]').addEventListener('click', () => { search.value = ''; filter(); search.focus(); }, options);
      this.querySelector('[data-brand-tools]').hidden = false;
      filter();
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  }
  customElements.define('brox-brand-directory', BrandDirectory);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
